module.exports = __webpack_public_path__ + "img/404.35579f45.svg";